var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.5498 6C8.59662 4.94955 9.05516 3.95979 9.82622 3.24488C10.5973 2.52996 11.6188 2.14741 12.6698 2.18H16.9998C18.0576 2.13662 19.0894 2.51434 19.8692 3.23038C20.6489 3.94641 21.1131 4.94237 21.1598 6V18C21.1156 19.0594 20.6526 20.0579 19.8726 20.7761C19.0925 21.4943 18.0592 21.8733 16.9998 21.83H12.6698C11.6172 21.8625 10.5942 21.4786 9.82283 20.7616C9.05149 20.0445 8.59406 19.0522 8.5498 18V6Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3099 11.25H5.39992L7.04992 9.61C7.19037 9.46937 7.26926 9.27875 7.26926 9.08C7.26926 8.88125 7.19037 8.69063 7.04992 8.55C6.98114 8.48076 6.89934 8.42581 6.80924 8.38831C6.71914 8.35082 6.62251 8.33151 6.52492 8.33151C6.42732 8.33151 6.33069 8.35082 6.24059 8.38831C6.15049 8.42581 6.06869 8.48076 5.99992 8.55L3.05992 11.47C2.91947 11.6106 2.84058 11.8012 2.84058 12C2.84058 12.1988 2.91947 12.3894 3.05992 12.53L5.99992 15.45C6.06882 15.5206 6.1513 15.5764 6.24239 15.6143C6.33348 15.6521 6.43129 15.671 6.52992 15.67C6.62846 15.6705 6.7261 15.6512 6.81711 15.6135C6.90812 15.5757 6.99067 15.5201 7.05992 15.45C7.20037 15.3094 7.27926 15.1188 7.27926 14.92C7.27926 14.7212 7.20037 14.5306 7.05992 14.39L5.39992 12.75H15.3099C15.5088 12.75 15.6996 12.671 15.8402 12.5303C15.9809 12.3897 16.0599 12.1989 16.0599 12C16.0599 11.8011 15.9809 11.6103 15.8402 11.4697C15.6996 11.329 15.5088 11.25 15.3099 11.25Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.009ea956c69b3441dff49ef3d38ed767.svg";
export { ForwardRef as ReactComponent };